module.exports = __webpack_public_path__ + "img/home-banner-bg.add77df8.jpg";